// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__2VodT","title":"Images45_title__3f8OO","images":"Images45_images__3GK4j"};